import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconMessagesDollar = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 17 17",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#a)",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M0 2.125C0 .953.953 0 2.125 0h12.75C16.047 0 17 .953 17 2.125v9.563a2.127 2.127 0 0 1-2.125 2.124H10.27l-4.107 3.082a.536.536 0 0 1-.558.05.523.523 0 0 1-.293-.475v-2.657H2.126A2.127 2.127 0 0 1 0 11.688V2.124Zm9.164 1.328A.666.666 0 0 0 8.5 2.79a.666.666 0 0 0-.664.664v.465a2.561 2.561 0 0 0-.737.282c-.462.276-.86.757-.857 1.458.004.674.399 1.099.82 1.351.366.22.82.359 1.182.465l.057.017c.418.126.724.225.93.355.169.106.192.18.195.272.004.166-.06.266-.196.349-.166.103-.428.166-.71.156-.369-.013-.714-.13-1.166-.282a10.063 10.063 0 0 0-.239-.08.665.665 0 0 0-.84.418.666.666 0 0 0 .419.84c.063.02.133.043.202.07.276.096.595.206.937.279v.491c0 .366.298.664.664.664a.666.666 0 0 0 .664-.664v-.458c.265-.056.531-.15.77-.299.475-.295.834-.8.824-1.494-.01-.674-.389-1.109-.817-1.381-.382-.24-.86-.385-1.232-.498l-.023-.007c-.425-.13-.728-.222-.94-.348-.173-.103-.176-.163-.176-.223 0-.123.046-.216.206-.309.18-.106.451-.169.714-.166.318.004.67.073 1.036.173a.664.664 0 1 0 .342-1.285 8.821 8.821 0 0 0-.7-.156v-.455Z"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 0h17v17H0z"
		})
	}) })]
});
export default SvgIconMessagesDollar;
